import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";
import store from "@/store";

export interface KeyValue<TValue> {
  key: string;
  value: TValue;
}

export enum KeyId {
  AttributeBuilderTourSeen = "AttributeBuilderTourSeen",
  BpCustomizationRevealPromptSeen = "BpCustomizationRevealPromptSeen",
  BpCustomizationIntroductionTourSeen = "BpCustomizationIntroductionTourSeen",
  BuildersNavigationSectionTourSeen = "BuildersNavigationSectionTourSeen",
  PlacementWflOnboardingTourSeen = "PlacementWflOnboardingTourSeen",
  SearchCustomizationTourSeen = "SearchCustomizationTourSeen",
}

export class KeyValueService {
  private generateKey(id: KeyId) {
    const user = store.state.auth.user;
    if (!user) {
      return;
    }
    return `user:${user.id}:${id}`;
  }

  protected async retrieve<TValue>(key: string) {
    return await axiosClient.get<{ data: KeyValue<TValue> }>(
      endpoints.KEY_VALUE,
      { params: { key } }
    );
  }

  protected async store<TValue>(payload: KeyValue<TValue>) {
    return await axiosClient.post<{ data: KeyValue<TValue> }>(
      endpoints.KEY_VALUE,
      payload
    );
  }

  async kvRequest<TValue>(
    key: KeyId,
    value?: TValue
  ): Promise<KeyValue<TValue | null>> {
    const generatedKey = this.generateKey(key);
    if (!generatedKey) {
      return { key: "", value: null };
    }
    const { data } =
      value === undefined
        ? await this.retrieve<TValue>(generatedKey)
        : await this.store<TValue>({ key: generatedKey, value });

    return data.data;
  }
}

const keyValueService = new KeyValueService();
export default keyValueService;
